<template>
  <div class="shop_detail">
    <div class="row">
      <div class="col-sm-12 col-md-8">
        <div class="p-0-14">
          <div class="content_top">
            <div>
              <!-- 内容 -->
              <!-- TODO -->
              <div class="p-0-14">
                <div class="name">
                  <span>【{{ item.pdName }}】</span>
                </div>
                <div class="price">
                  <div class="price_content">
                    <div class="price_content1">
                      <div v-if="$t('lang') === 'por'">
                        <span class="m-r-20"
                          >R${{ item.packages[0].prices.BRL.real }}</span
                        >
                        <span class="text-delete"
                          >R${{ item.packages[0].prices.BRL.price }}</span
                        >
                      </div>
                      <div v-else>
                        <span class="m-r-20"
                          >${{ item.packages[0].prices.USD.real }}</span
                        >
                        <span class="text-delete"
                          >${{ item.packages[0].prices.USD.price }}</span
                        >
                      </div>
                    </div>
                    <div class="price_content2">
                      {{ item.packages[0].pkgType }}
                    </div>
                  </div>
                </div>
                <div v-html="item.content"></div>
              </div>
            </div>
          </div>
          <!-- 支持的币种 -->
          <div class="content_top" style="padding-top: 0">
            <div class="content_top_title">
              {{ $t("subscription.payment_currency") }}
            </div>
            <div>
              <div
                v-for="c in currencies"
                :key="c.code"
                :class="
                  selected_curr.code === c.code
                    ? 'content_top_content_active'
                    : 'content_top_content'
                "
                @click="clickCurr(c)"
              >
                <div class="flex-between w-full">
                  <div>{{ c.code }}</div>
                  <div>{{ c.name }}</div>
                </div>
              </div>
            </div>
          </div>
          <!-- 套餐 -->
          <div class="content_top" style="padding-top: 0">
            <div class="content_top_title">
              {{ $t("subscription.payment_cycle") }}
            </div>
            <div>
              <div
                v-for="c in item.packages"
                :key="c.pkgId"
                :class="
                  selected_pkg.pkgId === c.pkgId
                    ? 'content_top_content_active'
                    : 'content_top_content'
                "
                @click="clickCycle(c)"
              >
                <!-- 美元 -->
                <div
                  class="flex-between w-full"
                  v-if="selected_curr.code === 'USD'"
                >
                  <!-- TODO -->
                  <div class="title12">
                    <span>
                      {{ c.pkgType }}
                    </span>
                  </div>
                  <div>
                    <span class="title11 m-r-10">${{ c.prices.USD.real }}</span>
                    <span class="text-delete-small"
                      >$ {{ c.prices.USD.price }}</span
                    >
                  </div>
                </div>
                <!-- 巴币 -->
                <div
                  class="flex-between w-full"
                  v-else-if="selected_curr.code === 'BRL'"
                >
                  <!-- TODO -->
                  <div class="title12">
                    <span>
                      {{ c.pkgType }}
                    </span>
                  </div>
                  <div>
                    <span class="title11 m-r-10"
                      >R${{ c.prices.BRL.real }}</span
                    >
                    <span class="text-delete-small"
                      >R$ {{ c.prices.BRL.price }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-xl-4">
        <div class="p-0-14">
          <!-- 优惠券 -->
          <div class="coupon_code">
            <div style="flex: 1">
              <el-input
                v-model="coupon_code"
                :placeholder="$t('prompt.enter_discount_code')"
              />
            </div>
            <div
              class="flex"
              style="
                background-color: #409eff;
                border: 1px solid #409eff;
                border-radius: 0 5px 5px 0;
                padding: 0 12px;
              "
            >
              <div
                style="display: flex; align-items: center; margin-right: 5px"
              >
                <img
                  style="width: 18px; height: 18px"
                  src="../../assets/img/shop/coupon.png"
                  alt=""
                />
              </div>
              <div
                style="font-size: 16px; font-weight: 500; color: white"
                class="c-p"
                @click="comfirm()"
              >
                {{ $t("prompt.verify") }}
              </div>
            </div>
          </div>
          <!-- 合计价格 -->
          <div class="coupon_order">
            <div style="margin: 0 0 16px; font-size: 18px; font-weight: 700">
              {{ $t("subscription.order_total") }}
            </div>
            <div
              style="font-size: 14px; margin: 0 0 16px; font-weight: 600"
              class="flex-between"
            >
              <div>
                <!-- //TODO -->
                <span>【{{ item.pdName }}】</span>
                ×
                <span>{{ selected_pkg.pkgType }}</span>
              </div>
              <div v-if="selected_curr.code === 'USD'">
                ${{ selected_pkg.prices.USD.real }}
              </div>
              <div v-else-if="selected_curr.code === 'BRL'">
                R${{ selected_pkg.prices.BRL.real }}
              </div>
            </div>
            <div>
              <el-divider />
            </div>
            <div style="font-size: 14px; color: grey; margin: 16px 0 0">
              {{ $t("subscription.total") }}
            </div>
            <div
              style="font-size: 36px; font-weight: 600; margin: 16px 0"
              v-if="selected_curr.code === 'USD'"
            >
              ${{ selected_pkg.prices.USD.real }}&nbsp;USD
            </div>
            <div
              style="font-size: 36px; font-weight: 600; margin: 16px 0"
              v-else-if="selected_curr.code === 'BRL'"
            >
              R${{ selected_pkg.prices.BRL.real }}&nbsp;BRL
            </div>
            <div style="width: 100%">
              <el-button
                style="width: 100%; font-size: 16px; font-weight: 600"
                type="primary"
                :disabled="placeDisabled"
                :loading="loading"
                @click="placeOrder()"
              >
                {{ $t("subscription.place_an_order") }}
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { order, payment } from "@/utils/api";
import { ElMessageBox, ElNotification } from "element-plus";
import { deCodeBase64 } from "@/utils/tool";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import Cookies from 'js-cookie'
export default {
  setup() {
    const { t } = useI18n();
    const store = useStore();
    return { t, store };
  },
  data() {
    return {
      item: {},
      cycle: [],
      coupon_code: "",
      selected_pkg: {},
      selected_curr: {},
      currencies: [],
      placeDisabled: true,
      loading: false,
    };
  },
  methods: {
    clickCycle(c) {
      this.selected_pkg = c;
    },
    clickCurr(c) {
      this.selected_curr = c;
    },
    //用户提交订单 返回状态码
    async submitOrder(force) {
      let param = {
        pkgId: this.selected_pkg.pkgId - 0,
        currency: this.selected_curr.code,
      };
      if (force !== null && force !== undefined) {
        param["force"] = force;
      }
      return new Promise((resolve) => {
        order(param).then((res) => {
          if (res !== undefined) {
            if (res.data.code === 0) {
              if (Object.keys(res.data.data).length !== 0) {
                resolve({ code: 0, data: res.data.data.orderNo });
                return;
              } else {
                ElNotification({
                  title: this.t("prompt.Mistake"),
                  message: this.t("prompt.no_order"),
                  type: "error",
                });
                resolve({ code: -1, data: "" });
                return;
              }
            } else if (res.data.code === 3) {
              if (res.data.data.length > 0) {
                resolve({ code: 3, data: res.data.data[0].no });
                return;
              }
            } else if (res.data.code === 4) {
              resolve({ code: 4, data: "" });
              return;
            }
            ElNotification({
              title: this.t("prompt.Mistake"),
              message: res.data.msg,
              type: "error",
            });
            resolve({ code: -1, data: "" });
            return;
          }
          ElNotification({
            title: "Error",
            message: "Network error",
            type: "error",
          });
          resolve({ code: -1, data: "" });
          return;
        });
      });
    },

    async placeOrder() {
      this.loading = true;
      let obj = await this.submitOrder();
      let code = obj.code;
      let orderNo = obj.data;
      //设置cookie
      Cookies.set("token", localStorage.getItem("token"), { domain: ".bestvpns.fyi"})
      if (code === 0) {
        this.loading = false;
        window.open(
          "/shopDetails/" + sessionStorage.getItem("lang") + "/" + orderNo,
          "_blank"
        );
        this.$router.push({
          name: "status",
          params: { params: orderNo },
        });
      } else if (code === 3) {
        this.loading = false;
        ElMessageBox.confirm(
          this.t("prompt.cancel_order"),
          this.t("orders.Attention"),
          {
            confirmButtonText: this.t("prompt.confirm_order_cancellation"),
            cancelButtonText: this.t("orders.cancel"),
            type: "warning",
          }
        )
          .then(() => {
            window.open(
              "/shopDetails/" + sessionStorage.getItem("lang") + "/" + orderNo,
              "_blank"
            );
            this.$router.push({
              name: "status",
              params: { params: orderNo },
            });
          })
          .catch(() => {});
      } else if (code === 4) {
        this.loading = false;
        ElMessageBox.confirm(
          this.t("prompt.has_subscripe"),
          this.t("orders.Attention"),
          {
            confirmButtonText: this.t("orders.sure"),
            cancelButtonText: this.t("orders.cancel"),
            type: "warning",
          }
        )
          .then(async () => {
            let obj = await this.submitOrder("1");
            if (obj.code === 0) {
              window.open(
                "/shopDetails/" +
                  sessionStorage.getItem("lang") +
                  "/" +
                  obj.data,
                "_blank"
              );
              this.$router.push({
                name: "status",
                params: { params: obj.data },
              });
            }
          })
          .catch(() => {});
      }

    },
    //验证优惠卷
    comfirm() {
      return ElNotification({
        title: this.t("prompt.Mistake"),
        message: this.t("prompt.invalid_discount_code"),
        type: "warning",
      });
    },
    getPayment() {
      payment().then((res) => {
        if (res !== undefined) {
          if (res.data.code === 0) {
            if (Object.keys(res.data.data).length !== 0) {
              this.currencies = res.data.data.currencies;
              this.placeDisabled = false;
              if (this.currencies.length > 0) {
                this.selected_curr = this.currencies[0];
              }
            } else {
              ElNotification({
                title: this.t("prompt.Mistake"),
                message: this.t("prompt.no_currencies"),
                type: "warning",
              });
            }
          } else {
            return ElNotification({
              title: this.t("prompt.Mistake"),
              message: res.data.msg,
              type: "error",
            });
          }
        } else {
          return ElNotification({
            title: "Error",
            message: "Network error",
            type: "error",
          });
        }
      });
    },
  },
  created() {
    this.item = JSON.parse(deCodeBase64(this.$route.params.obj));
    this.selected_pkg = this.item.packages[0];
    this.getPayment();
  },
  watch: {
    "$i18n.locale"() {
      this.getPayment();
    },
  },
};
</script>

<style lang="less" scoped>
.content_top_name {
  font-size: 20px;
  color: #212529;
  padding: 0 16px;
  font-weight: 600;
}

/deep/.el-input__wrapper {
  background-color: #35383d !important;
  border-radius: 5px 0 0 5px;
  box-shadow: transparent !important;
}

.coupon_code {
  background-color: #35383d;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.coupon_order {
  background-color: #35383d;
  padding: 16px;
  color: white;
}

.shop_detail {
  height: 100%;
  width: 100%;
  max-width: 1200px;
}

.row {
  display: flex;
  flex-wrap: wrap;
}

.content_top {
  background-color: rgb(255, 255, 255);
  border-radius: 0.25rem;
  margin-bottom: 1.75rem;
  box-shadow: 0 1px 3px rgba(228, 228, 228, 0.5),
    0 1px 2px rgba(228, 228, 228, 0.5);
  padding-bottom: 1rem;
  padding-top: 1rem;
}

.price {
  background-color: #e9ecef;
  transition: opacity 0.25s ease-out;
  margin: 0 auto;
  padding: 1.25rem 1.25rem 1px;
  overflow-x: visible;
}

.content_item {
  margin-bottom: 1.25rem;
  display: flex;
  align-content: center;
  align-items: center;
}

.content_top_title {
  padding: 12px 20px;
  font-size: 18px;
  background-color: #fafafa;
}

.content_top_content {
  display: flex;
  justify-content: space-between;
  // margin: -2px -2px -1px;
  padding: 20px;
  border: 3px solid transparent;
  cursor: pointer;
  border-radius: 5px;
}

.content_top_content_active {
  display: flex;
  justify-content: space-between;
  // margin: -2px -2px -1px;
  padding: 20px;
  border: 3px solid #409eff;
  cursor: pointer;
  border-radius: 5px;
}
</style>